// @ts-nocheck
import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';

Vue.config.productionTip = false

Vue.prototype.$weather = {
  conditions: {
    "3%%": {
      "default": "Tormenta",
      "200": "Tormenta con lluvia ligera",
      "201": "Tormenta con lluvia",
      "202": "Tormenta con lluvia torrencial",
      "212": "Tormenta fuerte"
    },
    "2%%": {
      "default": "Llovizna"
    },
    "5%%": {
      "default": "Lluvia",
      "500": "Lluvia ligera",
      "503": "Lluvia torrencial"
    },
    "6%%": {
      "default": "Nieve",
      "611": "Aguanieve",
      "612": "Aguanieve",
      "613": "Aguanieve"
    },
    "7%%": {
      "701": "Niebla",
      "711": "Humo",
      "721": "Neblina",
      "741": "Niebla",
      "751": "Arena",
      "731": "Polvo",
      "761": "Polvo",
      "762": "Ceniza",
      "781": "Tornado",
      "771": "Chubasco"
    },
    "8%%": {
      "800": "Despejado",
      "801": "Algunas nubes",
      "802": "Nubes dispersas",
      "803": "Nublado",
      "804": "Muy nublado"
    }
  },
  icons: {
    '01d': 'sunny', 
    '01n': 'night',
    '02d': 'partly-cloudy',
    '02n': 'night-partly-cloudy',
    '03d': 'cloudy',
    '03n': 'cloudy',
    '04d': 'cloudy',
    '04n': 'cloudy',
    '09d': 'rainy',
    '09n': 'rainy',
    '10d': 'pouring',
    '10n': 'pouring',
    '11d': 'lightning',
    '11n': 'lightning',
    '13d': 'snowy',
    '13n': 'snowy',
    '50d': 'fog',
    '50n': 'fog'
  }
}

new Vue({
  vuetify,
  render: h => h(App),
}).$mount('#app')
